module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('p', {
    ref: "message",
    class: _vm.alert_style
  }, [_vm._v(_vm._s(_vm.result_message))])]), _vm._v(" "), _c('p', {
    staticClass: "text-right mt-5"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("ログイン画面へ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('small', [_vm._v("メールアドレス変更完了")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e0a87792!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/profile/EditedEmail.vue
// module id = 361
// module chunks = 1